import React, {Component} from 'react';
import $ from 'jquery';
import {
    AJAX,
    showPreloader,
    hidePreloader,
    cross_form_errors,
    close_popup,
    show_popup,
    setEmailForMessages,
    addStepLog, setUrlSinglePageApp
} from "../functions";
import {Redirect} from "react-router-dom";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import moment from "moment";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack"
import {withRouter} from "react-router";

class GetVehiclePage extends Component {
    constructor(props) {
        super(props);
        this.handleSetPage = this.handleSetPage.bind(this);
        this.getVehicleAjax = this.getVehicleAjax.bind(this);
        this.setDisallowGoBack = this.setDisallowGoBack.bind(this);
        this.toggleOtherFields = this.toggleOtherFields.bind(this);
        this.onPasteNumberField = this.onPasteNumberField.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleSetPage({name: 'get_vehicle', params: false});

        this.state = {
            redirect: false,
            isDisplayNone: true,
            client_data: this.props.global_operation === 'lock' ? this.props.client_data : {resno: '', email: ''},
            resno: this.props.global_operation === 'lock' ? this.props.client_data.resno : '',
            email: this.props.global_operation === 'lock' ? this.props.client_data.email : '',
            statusPaste: false
        };

        /*let fields = this.props.field_list.get_vehicle;
        let client_data = this.props.client_data;
        for (let i in fields) {
            if (!client_data[fields[i]]) {
                this.state.isDisplayNone = false;
                break;
            }
        }*/

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    handleSetPage(options) {
        if (options.name == 'get_vehicle')
            addStepLog('Enter booking info (resno and email) Page', false);
        this.props.handleSetPage(options);
    }

    setDisallowGoBack() {
        this.props.setDisallowGoBack(false)
    }

    getVehicleAjax(event) {
        addStepLog('Press button GO on enter booking info (resno and email) Page', false);

        let fields = this.props.field_list.get_vehicle;
        let btn = event.target;
        let form_inputs = $(btn).closest('.form-inputs');
        let params = {};
        let t = this;

        for (let item in fields) {
            let el = form_inputs.find('[name='+fields[item]+']');
            if (el.length) {
                params[fields[item]] = el[0].value.trim();
            }
        }

        let entered_client_data = Object.assign({}, params);
        for (let i in fields) {
            if (entered_client_data[fields[i]] === undefined) {
                entered_client_data[fields[i]] = '';
            }
        }

        params.action = 'api/booking/get_vehicle';
		params.global_operation = t.props.global_operation;

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: function () {
                showPreloader();
            },
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length) {
                    addStepLog('Correct booking info and show booking data');
                    // entered_client_data = Object.assign({}, resp.data.client_data, entered_client_data);
                    let {
                        vehicle,
                        client_data,
                        booking_state,
                        return_instr_note
                    } = resp.data;
                    t.props.handleSetVehicleData(vehicle);
                    show_popup(<DataVerificationPrePopup
                        goNext={()=>{
                            t.props.handleSetClientData(entered_client_data);
                            localStorage.setItem('vehicle_locations', JSON.stringify(vehicle.Locations ? vehicle.Locations : {}));
                            t.props.handleSetRcmClientData(client_data);
                            t.props.handleSetBookingState(booking_state);
                            if (return_instr_note) {
                                t.props.handleSetReturnInstrNote(return_instr_note);
                            }
                            t.setDisallowGoBack();
                            t.setState({redirect: true});
                            setEmailForMessages(entered_client_data.email);
                        }}
                        vehicle={resp.data.vehicle}
                        client_data={resp.data.client_data}
                    />, {auto_close: false})

                } else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                    else {
                        showPopupWithGoBack('Can not find booking');
                    }
                }

                let errs_f = {};
                if (resp.errors !== undefined && resp.errors.form !== undefined) {
                    /*if (t.state.isDisplayNone) {
                        t.toggleOtherFields();
                    }*/
                    errs_f = resp.errors.form;

                }
                cross_form_errors(errs_f, fields, form_inputs);
                // t.props.handleSetSessionKey(resp.session_key);
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    toggleOtherFields(ev) {
        if (ev)
            ev.preventDefault();

        let t = this;

        $(t.refs['other_fields']).slideToggle(500, function () {

            t.setState({isDisplayNone:!t.state.isDisplayNone});
        });
    }

    onPasteNumberField(event) {
        let resno = event.clipboardData.getData('Text').replace(/\D+/g,"");
        this.setState({statusPaste: true, resno: resno});
    }

    onChange(event) {
        let n = event.target.name;
        let v = event.target.value.trim();
        if (!this.state.statusPaste) {
            if (n === 'resno') {
                v = v.replace(/[^0-9]/g, '');
            }
            this.setState({[n]: v})
        } else {
            this.setState({statusPaste: false});
        }
    }

    render() {
        if (this.state.redirect) {
            if (this.props.page_params.afterSubmitRedirectTo) {
                return <Redirect push to={this.props.page_params.afterSubmitRedirectTo} />
            } else
                return <Redirect push to="/vehicle_actions" />
        }

        return (<>
            <RedirectOnlyHome />
            <div className={'value-space'}>
                <div className="row">
                    <div className="offset-2 col-8 my-4 text-center">
                        <p>Please enter the <b>Vehicle Rental Agreement Number</b> and the <b>Email Address</b> associated with this booking.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8 text-center form-inputs">
                        <h2 style={{whiteSpace: "nowrap"}}>Vehicle Rental Agreement Number <i className="find_rental_agreement" onClick={() => show_popup(<PopupFindReservationNumber />, {auto_close: false}) }>&nbsp;</i></h2>
                        <div className="form-group">
                            <input type="text" className="form-control base-input" name="resno"
                                   inputMode="numeric"
                                   placeholder="Vehicle Rental Agreement Number" min="0"
                                   value={this.state.resno}
                                   onChange={this.onChange}
                                   onPaste={this.onPasteNumberField}
                                   pattern="[0-9]"
                                   onInput={(ev)=>ev.target.value=ev.target.value.replace(/[^0-9]/g,'')}
                            />
                            <div id="resno_errors" />
                        </div>
                        <h2>Email Address</h2>
                        <div className="form-group mb-4">
                            <input type="email" className="form-control base-input" name="email" placeholder="Email Address" value={this.state.email} onChange={this.onChange} />
                            <div id="email_errors" />
                        </div>
                        {/*<div ref="other_fields" style={{display: (this.state.isDisplayNone ? 'none' : 'block')}}>
                            <h2>Mobile Number</h2>
                            <div className="form-group mb-4">
                                <input type="text" className="form-control base-input" name="mobile" placeholder="Mobile Number" defaultValue={client_data.mobile} />
                                <div id="mobile_errors" />
                            </div>

                            <h2>Date of Birth</h2>
                            <div className="form-group mb-4">
                                <input type="date" className="form-control base-input" name="dob" placeholder="Date Of Birth" defaultValue={client_data.dob} />
                                <div id="dob_errors" />
                            </div>
                            <h2>Driver License Number</h2>
                            <div className="form-group">
                                <input type="text" className="form-control base-input" name="driver_license" placeholder="Driver License Number" defaultValue={client_data.driver_license} />
                                <div id="driver_license_errors" />
                            </div>
                        </div>
                        <a className="blue-link" onClick={this.toggleOtherFields}>{this.state.isDisplayNone ? 'Show ' : 'Hide '}Other Fields</a>*/}
                        <div className="d-flex justify-content-center align-items-center mt-4">
                            <div className="go-btn go-submit" onClick={this.getVehicleAjax.bind(this)}/>
                        </div>
                    </div>
                </div>
            </div>
        </>);
    }
}

class DataVerificationPrePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    goNext() {
        addStepLog('Press button goNext on popup booking info');
        this.props.goNext();
    }

    proceed() {
        close_popup();
        this.goNext();
    }

    goBack() {
        addStepLog('Press button goBack on popup booking info', false);
        close_popup();
    }

    render() {
        let cd = this.props.client_data;
        let v = this.props.vehicle;
        let fromFormatDate = 'YYYY-MM-DD';
        let toFormatDate = 'DD/MM/YYYY';
        let dob = moment(cd.dob, fromFormatDate).format(toFormatDate);
        let pickupDate = moment(v.PickupDate, fromFormatDate).format(toFormatDate);
        let dropOffDate = moment(v.DropOffDate, fromFormatDate).format(toFormatDate);
        return (
            <div className="row">
                <div className="col-12">
                    <div className="row mt-2 mx-3 text-center">
                        <div className="col-12">
                            <h2>Is this your booking?</h2>
                        </div>
                    </div>
                    <div className="row mx-3">
                        <table className="table table-striped table-bordered table-sm">
                            <tbody>
                            <tr>
                                <th className="align-middle" scope="row">Pickup Date:</th>
                                <td className="align-middle">{pickupDate}</td>
                            </tr>
                             <tr>
                                <th className="align-middle" scope="row">Drop Off Date:</th>
                                <td className="align-middle">{dropOffDate}</td>
                            </tr>
                            <tr>
                                <th className="align-middle" scope="row">Make of Vehicle:</th>
                                <td className="align-middle">{v.Make}</td>
                            </tr>
                            <tr>
                                <th className="align-middle" scope="row">Model of Vehicle:</th>
                                <td className="align-middle">{v.Model}</td>
                            </tr>
                            <tr>
                                <th className="align-middle" scope="row">Registration Number:</th>
                                <td className="align-middle">{v.RegistrationNo}</td>
                            </tr>
                            <tr>
                                <th className="align-middle" scope="row">Your Last Name:</th>
                                <td className="align-middle">{cd.last_name}</td>
                            </tr>
                            <tr>
                                <th className="align-middle" scope="row">Your First Name:</th>
                                <td className="align-middle">{cd.first_name}</td>
                            </tr>
                            <tr>
                                <th className="align-middle" scope="row">Your Date of Birth:</th>
                                <td className="align-middle">{dob}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row mx-3 mb-2 text-center">
                        <div className="col-6">
                            <button type="button" className="go-btn go-back" onClick={this.goBack.bind(this)} />
                        </div>
                        <div className="col-6 text-center">
                            <button type="button" className="go-btn go-next" onClick={this.proceed.bind(this)}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class PopupFindReservationNumber extends Component {
    constructor(props) {
        super(props);
        this.goBack = this.goBack.bind(this);
    }

    goBack() {
        close_popup();
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <div className="row m-3">
                        <div className="col-12 text-center">
                            Your rental agreement number can be found on your hire agreement, in the highlighted area in the image below.
                        </div>
                    </div>
                    <div className="row m-3">
                        <div className="col-12 text-center find-reservation-number">
                            <img src={init_plugin_dir + '../images/res_number.png'} alt="Banner"/>
                        </div>
                    </div>
                    <div className="row mx-3 mb-3">
                        <div className="go-btn go-back mx-auto" onClick={this.goBack} />
                    </div>
                </div>
            </div>
        )
    }
}

const GetVehiclePageR = withRouter(GetVehiclePage);
export default GetVehiclePageR;